export enum CommentSortOptions {
  newest = 'newest',
  oldest = 'oldest',
  mostReactions = 'most-reactions',
  highestScore = 'highest-score',
  lowestScore = 'lowest-score',
}
